import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full py-6 px-4 bg-white border-t border-slate-200 mt-auto text-center">
      <div className="max-w-4xl mx-auto flex flex-col items-center justify-center gap-3">
        <img
          src="https://ftp.pcnpublicidad.com/adium/footer_legal.png"
          alt="Footer Legal Adium"
          className="max-w-full h-auto max-h-24 object-contain mx-auto"
        />
        <p className="text-[11px] text-slate-400 font-light">
          © {new Date().getFullYear()} ADIUM. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
